import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

interface Category {
  id: number;
  image: string;
  name: string;
  featured: boolean;
  totalCourses: number;
}

@Component({
  selector: 'app-categories',
  standalone: false,
  templateUrl: './categories.html',
  styleUrl: './categories.scss',
})
export class Categories implements OnInit {
  pageTitle = 'Category List';

  pageSubtitle =
    'View, manage, and organize all course categories in one place.';

  searchTerm = '';

  page = 1;
  pageSize = 8;

  categories: Category[] = [
    {
      id: 1,
      image: '../assets/img/cr-1.webp',
      name: 'Finance & Accounting',
      featured: false,
      totalCourses: 0,
    },
    {
      id: 2,
      image: '../assets/img/cr-2.webp',
      name: 'Business',
      featured: true,
      totalCourses: 12,
    },
    {
      id: 3,
      image: '../assets/img/cr-3.jpg',
      name: 'Development',
      featured: true,
      totalCourses: 24,
    },
    {
      id: 4,
      image: '../assets/img/cr-4.jpg',
      name: 'IT & Software',
      featured: false,
      totalCourses: 16,
    },
    {
      id: 5,
      image: '../assets/img/cr-5.jpg',
      name: 'Design',
      featured: true,
      totalCourses: 8,
    },
    {
      id: 6,
      image: '../assets/img/cr-6.jpg',
      name: 'Personal Development',
      featured: false,
      totalCourses: 10,
    },
    {
      id: 7,
      image: '../assets/img/cr-7.webp',
      name: 'Marketing',
      featured: true,
      totalCourses: 7,
    },
    {
      id: 8,
      image: '../assets/img/cr-8.webp',
      name: 'Photography & Video',
      featured: false,
      totalCourses: 5,
    },
    {
      id: 9,
      image: '../assets/img/cr-9.jpg',
      name: 'Health & Fitness',
      featured: false,
      totalCourses: 9,
    },
    {
      id: 10,
      image: '../assets/img/cr-1.webp',
      name: 'Music',
      featured: true,
      totalCourses: 6,
    },
    {
      id: 11,
      image: '../assets/img/cr-2.webp',
      name: 'Teaching & Academics',
      featured: false,
      totalCourses: 11,
    },
    {
      id: 12,
      image: '../assets/img/cr-3.jpg',
      name: 'Office Productivity',
      featured: false,
      totalCourses: 4,
    },
  ];

  filteredCategories: Category[] = [];

  constructor(
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.applyFilters();
  }

  get paginatedCategories(): Category[] {
    const startIndex =
      (this.page - 1) * this.pageSize;

    const endIndex =
      startIndex + this.pageSize;

    return this.filteredCategories.slice(
      startIndex,
      endIndex
    );
  }

  get startItem(): number {
    if (this.filteredCategories.length === 0) {
      return 0;
    }

    return (
      (this.page - 1) * this.pageSize + 1
    );
  }

  get endItem(): number {
    return Math.min(
      this.page * this.pageSize,
      this.filteredCategories.length
    );
  }

  onSearchChange(): void {
    this.page = 1;
    this.applyFilters();
  }

 onPageSizeChange(event: Event): void {
  const selectElement =
    event.target as HTMLSelectElement;

  this.pageSize = Number(
    selectElement.value
  );

  this.page = 1;
}

  applyFilters(): void {
    const normalizedSearch =
      this.searchTerm
        .trim()
        .toLowerCase();

    this.filteredCategories =
      this.categories.filter((category) =>
        category.name
          .toLowerCase()
          .includes(normalizedSearch)
      );

    const lastAvailablePage = Math.max(
      1,
      Math.ceil(
        this.filteredCategories.length /
          this.pageSize
      )
    );

    if (this.page > lastAvailablePage) {
      this.page = lastAvailablePage;
    }
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.page = 1;

    this.applyFilters();
  }

  addCategory(): void {
    this.router.navigate([
      '/admin/course-reference/add-category'
    ]);
  }

  editCategory(category: Category): void {
    this.router.navigate([
      '/admin/course-reference/category/edit',
      category.id
    ]);
  }

  deleteCategory(category: Category): void {
    console.log(
      'Delete category:',
      category
    );
  }

  trackByCategoryId(
    _index: number,
    category: Category
  ): number {
    return category.id;
  }
}